import { Pagination } from '@mui/material'

import './index.css'

const PaginationComponent = ({ value, config={}, events={} }) => {
    const handleChange = (event, page) => {
        if (events.handleChange)
            events.handleChange(page)
    }

    return (
        <div className="c-Pagination">
            <Pagination
                count={config.lastPage || 1}
                page={value || 1}
                onChange={handleChange}
                color="primary"
                shape="rounded"
                size={config.size || 'medium'}
            />
        </div>
    )
}

export { PaginationComponent }
